/* =====================================================================
   Organic Cotton Plus — App logic
   Cart + wishlist (localStorage), drawer, finder tabs, carousel arrows,
   search, newsletter, smooth interactions.
   ===================================================================== */
(function () {
  'use strict';

  // ---------- STORAGE ----------
  var KEY_CART = 'ocp.cart.v1';
  var KEY_WISH = 'ocp.wishlist.v1';
  // A wishlist app can take over the feature; when it does the theme stops drawing its own hearts so
  // shoppers do not see two. Set from the theme setting via the data attribute below.
  var BUILTIN_WISHLIST = document.documentElement.getAttribute('data-ocp-wishlist') !== 'off';
  var KEY_COMMENT = 'ocp.cart.comment.v1';
  var KEY_PROMO = 'ocp.cart.promo.v1';
  // Free-shipping threshold is merchant-editable: Theme settings → Cart → "Free shipping threshold".
  // layout/theme.liquid emits window.OCP_FREE_SHIP from settings.free_shipping_threshold (before this
  // script). Falls back to 75 if absent. (typeof check so a deliberate 0 = "always free" is honoured.)
  var FREE_SHIP_THRESHOLD = (typeof window.OCP_FREE_SHIP === 'number') ? window.OCP_FREE_SHIP : 75;
  // No hardcoded discounts. On the live theme, ocp-cart-shopify.js owns all discount + note logic via
  // the real Shopify Cart AJAX API (/cart/update.js); this map is intentionally empty (legacy fallback only).
  var PROMOS = {};
  var REAL_CART = !!(window.OCP_ROUTES && window.OCP_ROUTES.cart_add); // real Shopify cart layer active?

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); }
    catch (e) { return []; }
  }
  function write(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); }
    catch (e) {}
  }

  function getCart()  { return read(KEY_CART); }
  function getWish()  { return read(KEY_WISH); }
  // Saved items are keyed by product handle: it survives across environments and can be resolved
  // back to a live product via /products/<handle>.js, which a numeric id cannot without a catalogue
  // index. Older saves that stored an id simply will not resolve and are dropped on render.
  function wishKey(el) {
    return el.getAttribute('data-product-handle') || el.getAttribute('data-product-id');
  }
  function setCart(v) { write(KEY_CART, v); refresh(); }
  function setWish(v) { write(KEY_WISH, v); refresh(); }

  // ---------- HELPERS ----------
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function fmt(n) {
    var amount = Number(n) || 0;
    return '$' + amount.toFixed(2);
  }

  function bind(name, value) {
    $$('[data-bind="' + name + '"]').forEach(function (el) {
      el.textContent = value;
    });
  }

  // ---------- REFRESH UI ----------
  function refresh() {
    var cart = getCart();
    var wish = getWish();
    var count = cart.reduce(function (s, x) { return s + (x.qty || 1); }, 0);
    bind('cart-count', String(count));
    bind('cart-count-inline', '(' + count + ')');
    bind('wishlist-count', String(wish.length));

    // sync heart icons
    $$('[data-product-handle], [data-product-id]').forEach(function (el) {
      var id = wishKey(el);
      var liked = wish.indexOf(id) >= 0;
      $$('[data-action="toggle-wish"]', el).forEach(function (b) {
        b.classList.toggle('is-on', liked);
        b.setAttribute('aria-pressed', liked ? 'true' : 'false');
      });
    });

    renderCart();
    renderWishlistPage();
    syncStickyCheckout();
  }

  function syncStickyCheckout() {
    var count = getCart().reduce(function (sum, item) { return sum + (item.qty || 1); }, 0);
    var show = count > 0 && window.scrollY > 24;
    $$('.cart-sticky').forEach(function (el) { el.classList.toggle('is-visible', show); });
  }

  // Compact line used in the slide-out drawer
  function cartLineHTML(item) {
    var line = (item.price || 0) * (item.qty || 1);
    var media = item.image
      ? 'background-image:url(' + escAttr(item.image) + ');background-size:cover;background-position:center'
      : 'background:' + escAttr(item.swatch || '#eee');
    return ''
      + '<article class="cart-line" data-id="' + escAttr(item.id) + '">'
      +   '<div class="cart-line__img" style="' + media + '"></div>'
      +   '<div class="cart-line__body">'
      +     '<h3 class="cart-line__name">' + esc(item.name) + '</h3>'
      +     '<p class="cart-line__meta">' + esc(item.desc || '') + '</p>'
      +     '<div class="cart-line__qty">'
      +       '<button type="button" data-action="cart-dec" aria-label="Decrease">−</button>'
      +       '<span>' + (item.qty || 1) + '</span>'
      +       '<button type="button" data-action="cart-inc" aria-label="Increase">+</button>'
      +     '</div>'
      +   '</div>'
      +   '<div class="cart-line__right">'
      +     '<span class="cart-line__price">' + fmt(line) + '</span>'
      +     '<button type="button" class="cart-line__remove" data-action="cart-remove" aria-label="Remove">Remove</button>'
      +   '</div>'
      + '</article>';
  }

  // Full table row used on the cart page + popup modal (matches Figma)
  function cartRowHTML(item) {
    var line = (item.price || 0) * (item.qty || 1);
    var media = item.image
      ? 'background-image:url(' + escAttr(item.image) + ');background-size:cover;background-position:center'
      : 'background:' + escAttr(item.swatch || '#eee');
    var href = 'product.html?id=' + encodeURIComponent(item.id);
    return ''
      + '<article class="cart-row" data-id="' + escAttr(item.id) + '">'
      +   '<div class="cart-row__product">'
      +     '<a class="cart-row__media" href="' + href + '" style="' + media + '" aria-label="' + escAttr(item.name) + '">'
      +       (BUILTIN_WISHLIST ? '<button type="button" class="cart-row__wish" data-action="toggle-wish" aria-label="Save to wishlist" aria-pressed="false">' : '')
      +         '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" aria-hidden="true"><path d="M12 21s-7-4.5-9.3-9A5.3 5.3 0 0 1 7.5 5.5c1.7 0 3.3.8 4.5 2.2 1.2-1.4 2.8-2.2 4.5-2.2A5.3 5.3 0 0 1 21.3 12C19 16.5 12 21 12 21z"/></svg>'
      +       '</button>'
      +     '</a>'
      +     '<div class="cart-row__info">'
      +       '<a class="cart-row__name" href="' + href + '">' + esc(item.name) + '</a>'
      +       '<p class="cart-row__sku">Product # SKU# ' + esc(String(item.id || '').toUpperCase()) + '</p>'
      +       '<p class="cart-row__color">Color: ' + esc(item.color || item.desc || 'Default') + ' <span class="cart-row__dot" style="background:' + escAttr(item.swatch || '#999') + '"></span></p>'
      +     '</div>'
      +   '</div>'
      +   '<div class="cart-row__price"><span class="cart-row__mlabel">Price</span><span>' + fmt(item.price || 0) + '<small> /yard</small></span></div>'
      +   '<div class="cart-row__qty">'
      +     '<span class="cart-row__mlabel">QTY</span>'
      +     '<div class="cart-row__stepper">'
      +       '<button type="button" class="cart-row__qbtn" data-action="cart-dec" aria-label="Decrease quantity"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg></button>'
      +       '<span class="cart-row__qval"><b>' + (item.qty || 1) + '</b> yd(s)</span>'
      +       '<button type="button" class="cart-row__qbtn" data-action="cart-inc" aria-label="Increase quantity"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>'
      +     '</div>'
      +   '</div>'
      +   '<div class="cart-row__total"><span class="cart-row__mlabel">Total</span><span>' + fmt(line) + '</span></div>'
      +   '<button type="button" class="cart-row__remove" data-action="cart-remove" aria-label="Remove ' + escAttr(item.name) + '">'
      +     '<svg class="cart-row__remove-x" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>'
      +     '<svg class="cart-row__remove-trash" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><g clip-path="url(#clip0_cart_trash)"><path d="M2.66797 4.6665H13.3346" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.66797 7.3335V11.3335" stroke="black" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.33203 7.3335V11.3335" stroke="black" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.33203 4.6665L3.9987 12.6665C3.9987 13.0201 4.13917 13.3593 4.38922 13.6093C4.63927 13.8594 4.97841 13.9998 5.33203 13.9998H10.6654C11.019 13.9998 11.3581 13.8594 11.6082 13.6093C11.8582 13.3593 11.9987 13.0201 11.9987 12.6665L12.6654 4.6665" stroke="black" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 4.66667V2.66667C6 2.48986 6.07024 2.32029 6.19526 2.19526C6.32029 2.07024 6.48986 2 6.66667 2H9.33333C9.51014 2 9.67971 2.07024 9.80474 2.19526C9.92976 2.32029 10 2.48986 10 2.66667V4.66667" stroke="black" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_cart_trash"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>'
      +   '</button>'
      + '</article>';
  }

  function renderCart() {
    // The real Shopify cart layer (ocp-cart-shopify.js) owns all cart rendering when OCP_ROUTES is
    // present. Bail so this prototype localStorage cart never clobbers the server-rendered cart page
    // (which caused the page to flash/jump on load) or the AJAX-rendered popup/drawer.
    if (window.OCP_ROUTES && window.OCP_ROUTES.cart_add) return;
    var cart = getCart();
    var rawSubtotal = 0, itemCount = 0;
    cart.forEach(function (item) {
      rawSubtotal += (item.price || 0) * (item.qty || 1);
      itemCount += (item.qty || 1);
    });
    var promo = readPromo();
    var discount = (promo && PROMOS[promo]) ? rawSubtotal * PROMOS[promo] : 0;
    var total = rawSubtotal - discount;

    // Fill every cart shell (drawer / popup / page) with the right row layout
    $$('[data-bind="cart-body"]').forEach(function (body) {
      var isTable = body.getAttribute('data-cart-variant') === 'table';
      if (!cart.length) {
        body.innerHTML = isTable
          ? '<p class="cart-table__empty">Your bag is empty.</p>'
          : '<p class="cart-drawer__empty">Your bag is empty.</p>';
        return;
      }
      body.innerHTML = cart.map(isTable ? cartRowHTML : cartLineHTML).join('');
    });

    // Totals fan out to all shells (bind targets every matching element)
    bind('cart-subtotal', fmt(total));            // drawer single-line total
    bind('cart-page-subtotal', fmt(rawSubtotal));
    bind('cart-page-discount', '- ' + fmt(discount));
    bind('cart-page-shipping', total >= FREE_SHIP_THRESHOLD ? 'FREE' : 'Calculated at checkout');
    bind('cart-page-total', fmt(total));
    bind('cart-total', fmt(total));
    bind('cart-item-count', String(itemCount));

    // Cart page: swap content for empty-state when bag is empty
    $$('[data-bind="cart-page-content"]').forEach(function (el) { el.hidden = !cart.length; });
    $$('[data-bind="cart-page-empty"]').forEach(function (el) { el.hidden = !!cart.length; });

    renderFreeShipProgress(total);
    renderCartUpsell(cart);
    syncCartComment();
    syncPromoInput();
  }

  function renderFreeShipProgress(total) {
    var qualified = total >= FREE_SHIP_THRESHOLD;
    var msgHTML = qualified
      ? '🎉 You\'ve unlocked <strong>FREE delivery</strong>!'
      : 'Add <strong>' + fmt(FREE_SHIP_THRESHOLD - total) + '</strong> more to unlock <strong>FREE delivery</strong>';
    var pct = qualified ? 100 : Math.max(0, Math.min(100, (total / FREE_SHIP_THRESHOLD) * 100));
    $$('[data-bind="cart-ship-msg"]').forEach(function (msg) { msg.innerHTML = msgHTML; });
    $$('[data-bind="cart-ship-bar"]').forEach(function (bar) { bar.style.width = pct.toFixed(1) + '%'; });
    $$('[data-bind="cart-ship-progress"]').forEach(function (bg) { bg.setAttribute('aria-valuenow', String(Math.round(pct))); });
  }

  function renderCartUpsell(cart) {
    var sections = $$('[data-bind="cart-upsell"]');
    var rails = $$('[data-bind="cart-upsell-list"]');
    if (!sections.length || !rails.length) return;
    var inCart = {};
    cart.forEach(function (i) { inCart[i.id] = true; });
    var picks = cart.length
      ? (window.OCP_PRODUCTS || []).filter(function (p) { return !inCart[p.id]; }).slice(0, 4)
      : [];
    var html = picks.map(function (p) {
      return ''
        + '<article class="cart-upsell-card" data-product-id="' + escAttr(p.id) + '">'
        +   '<a href="product.html?id=' + encodeURIComponent(p.id) + '" class="cart-upsell-card__media" aria-label="' + escAttr(p.name) + '" style="background:' + escAttr(p.swatch || '#eee') + (p.image ? ';background-image:url(' + escAttr(p.image) + ');background-size:cover;background-position:center' : '') + '"></a>'
        +   '<a href="product.html?id=' + encodeURIComponent(p.id) + '" class="cart-upsell-card__name">' + esc(p.name) + '</a>'
        +   '<span class="cart-upsell-card__price">' + fmt(p.price || 0) + '</span>'
        +   '<button type="button" class="cart-upsell-card__add" data-action="add-to-cart" aria-label="Add ' + escAttr(p.name) + ' to bag">+ Add</button>'
        + '</article>';
    }).join('');
    rails.forEach(function (rail) { rail.innerHTML = html; });
    sections.forEach(function (sec) { if (picks.length) sec.removeAttribute('hidden'); else sec.setAttribute('hidden', ''); });
  }

  function readComment() { try { return localStorage.getItem(KEY_COMMENT) || ''; } catch (e) { return ''; } }
  function writeComment(v) { try { localStorage.setItem(KEY_COMMENT, v); } catch (e) {} }
  function readPromo() { try { return localStorage.getItem(KEY_PROMO) || ''; } catch (e) { return ''; } }
  function writePromo(v) { try { localStorage.setItem(KEY_PROMO, v); } catch (e) {} }

  function syncCartComment() {
    if (REAL_CART) return; // server-persisted cart.note owns the textarea (ocp-cart-shopify.js)
    var c = readComment();
    $$('textarea[data-action="cart-comment"]').forEach(function (t) { if (t.value !== c) t.value = c; });
  }
  function syncPromoInput() {
    if (REAL_CART) return; // real discounts come from the Shopify API (ocp-cart-shopify.js), not this map
    var code = readPromo();
    $$('[data-action="apply-promo"] input[name="promo"]').forEach(function (inp) {
      if (code && inp.value !== code) inp.value = code;
    });
    $$('[data-bind="promo-msg"]').forEach(function (msg) {
      if (code && PROMOS[code]) {
        msg.textContent = 'Code ' + code + ' applied — ' + Math.round(PROMOS[code] * 100) + '% off';
        msg.classList.add('is-ok'); msg.classList.remove('is-err');
      } else if (code) {
        msg.textContent = 'Invalid code';
        msg.classList.add('is-err'); msg.classList.remove('is-ok');
      } else {
        msg.textContent = '';
        msg.classList.remove('is-ok', 'is-err');
      }
    });
  }

  function applyPromo(code) {
    if (REAL_CART) return; // ocp-cart-shopify.js applies the real discount via /cart/update.js
    code = (code || '').trim().toUpperCase();
    writePromo(code);
    refresh();
  }

  // Saved products are fetched from Shopify by handle rather than read from a bundled catalogue, so
  // the page always shows live titles, prices and images. Results are memoised because refresh()
  // runs on every cart/wishlist change and re-fetching each time would be wasteful.
  var wishProductCache = {};
  var wishRenderedKey = null;
  function renderWishlistPage() {
    var grid = document.getElementById('wishlist-grid');
    if (!grid) return;
    var emptyEl = document.getElementById('wishlist-empty');
    var wish = getWish().filter(function (h) { return h && !/^\d+$/.test(h); });
    var key = wish.join(',');
    if (key === wishRenderedKey) return;
    wishRenderedKey = key;

    if (!wish.length) {
      grid.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    grid.setAttribute('aria-busy', 'true');
    Promise.all(wish.map(function (handle) {
      if (wishProductCache[handle] !== undefined) return wishProductCache[handle];
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (p) { wishProductCache[handle] = p; return p; });
    })).then(function (list) {
      if (key !== wishRenderedKey) return; // a newer render superseded this one
      var found = list.filter(Boolean);
      grid.removeAttribute('aria-busy');
      if (!found.length) {
        grid.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      grid.innerHTML = found.map(wishCardHTML).join('');
    });
  }

  function wishCardHTML(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var priced = (p.variants || []).filter(function (v) { return !/swatch|sample/i.test(v.title || ''); })[0]
      || (p.variants || [])[0] || {};
    var unitRaw = (priced.title || '').split(' / ')[0].split(' ')[0];
    var unit = unitRaw && !/^(default|title)$/i.test(unitRaw) && unitRaw.indexOf('$') < 0
      ? '/' + unitRaw.replace(/\(s\)/i, '').toLowerCase() : '';
    return ''
      + '<article class="pcard wish-card" data-product-id="' + escAttr(p.id) + '" data-product-handle="' + escAttr(p.handle) + '">'
      +   '<a class="pcard__media" href="/products/' + escAttr(p.handle) + '" aria-label="' + escAttr(p.title) + '"'
      +     (img ? ' style="background-image: url(&quot;' + escAttr(img) + '&quot;)"' : '') + '>'
      +     '<span class="pcard__media-top">'
      +       '<span></span>'
      +       '<button type="button" class="pcard__like is-on" data-action="toggle-wish" data-product="' + escAttr(p.handle) + '" aria-label="Remove from wishlist" aria-pressed="true">'
      +         '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 21s-7-4.5-9.3-9A5.3 5.3 0 0 1 7.5 5.5c1.7 0 3.3.8 4.5 2.2 1.2-1.4 2.8-2.2 4.5-2.2A5.3 5.3 0 0 1 21.3 12C19 16.5 12 21 12 21z"/></svg>'
      +       '</button>'
      +     '</span>'
      +   '</a>'
      +   '<div class="pcard__body">'
      +     '<a class="pcard__name" href="/products/' + escAttr(p.handle) + '">' + esc(p.title) + '</a>'
      +     '<span class="pcard__price"><b>' + esc(fmt((priced.price || p.price || 0) / 100)) + '</b>'
      +       (unit ? '<small> ' + esc(unit) + '</small>' : '') + '</span>'
      +   '</div>'
      + '</article>';
  }

  // ---------- ESCAPING ----------
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escAttr(s) { return esc(s); }

  // ---------- PRODUCT CARD (All Products listing — matches Figma Component 112) ----------
  function ratingStarsHTML(rating) {
    var full = Math.round(rating || 0);
    var s = '';
    for (var i = 0; i < 5; i++) {
      s += '<svg class="pcard__star" width="16" height="16" viewBox="0 0 24 24" fill="' + (i < full ? '#f5b042' : '#d8d5cd') + '" aria-hidden="true"><path d="M12 2l3 7h7l-5.5 4.5L18 21l-6-4-6 4 1.5-7.5L2 9h7z"/></svg>';
    }
    return s;
  }

  // Master fabric palette — used to flesh out each product's swatch row so the
  // slider has a realistic number of colours (a real PDP shows many shades).
  var SWATCH_PALETTE = [
    '#6fa182','#9d90cc','#c78fc1','#d99a98','#8cc966','#a8c1e3','#5b6b78','#3a8e8c',
    '#e8dcc6','#d6c39e','#a4b89a','#3d4a40','#d2a6a4','#9c5b5e','#b9a98a','#e2d6bf',
    '#9bb188','#f0e7d4','#3a4a66','#c8a89c','#cdd1c8','#5d5754'
  ];
  function swatchesFor(p) {
    var out = (p.shades && p.shades.length) ? p.shades.slice() : [p.swatch || '#ddd'];
    var seen = {}; out.forEach(function (h) { seen[h.toLowerCase()] = 1; });
    for (var i = 0; i < SWATCH_PALETTE.length && out.length < 12; i++) {
      var h = SWATCH_PALETTE[i];
      if (!seen[h.toLowerCase()]) { out.push(h); seen[h.toLowerCase()] = 1; }
    }
    return out;
  }
  var LENGTH_OPTIONS = ['1-4', '5-9', '10-19', '20-49', '50+'];

  function swatchListHTML(p) {
    return swatchesFor(p).map(function (hex, i) {
      return '<button type="button" class="pcard__sw' + (i === 0 ? ' is-active' : '') + '" data-action="sw-select" style="background:' + escAttr(hex) + '" aria-label="Colour ' + (i + 1) + '"></button>';
    }).join('');
  }

  function lengthMenuHTML() {
    return LENGTH_OPTIONS.map(function (opt, i) {
      return '<button type="button" class="pcard__length-opt' + (i === 0 ? ' is-active' : '') + '" data-action="length-pick" role="option" aria-selected="' + (i === 0 ? 'true' : 'false') + '">' + opt + '</button>';
    }).join('');
  }

  function productCardHTML(p) {
    var badgeHTML = '';
    if (p.tag === 'sale') badgeHTML = '<span class="pcard__badge pcard__badge--sale">Sale</span>';
    else if (p.tag === 'top') badgeHTML = '<span class="pcard__badge pcard__badge--top">Top Choice</span>';
    else if (p.tag === 'last') badgeHTML = '<span class="pcard__badge pcard__badge--last">Last Pieces</span>';

    var href = 'product.html?id=' + encodeURIComponent(p.id);
    var mediaStyle = p.image ? ' style="background-image:url(' + escAttr(p.image) + ')"' : '';

    return ''
      + '<article class="pcard" data-product-id="' + escAttr(p.id) + '" data-qty="1" data-price="' + (p.price || 0) + '">'
      +   '<a class="pcard__media prod-card__media--' + escAttr(p.shade || 'neutral') + '" href="' + href + '" aria-label="' + escAttr(p.name) + '"' + mediaStyle + '>'
      +     '<span class="pcard__media-top">'
      +       (badgeHTML || '<span></span>')
      +       (BUILTIN_WISHLIST ? '<button type="button" class="pcard__like" data-action="toggle-wish" aria-label="Save to wishlist" aria-pressed="false">' : '')
      +         '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 21s-7-4.5-9.3-9A5.3 5.3 0 0 1 7.5 5.5c1.7 0 3.3.8 4.5 2.2 1.2-1.4 2.8-2.2 4.5-2.2A5.3 5.3 0 0 1 21.3 12C19 16.5 12 21 12 21z"/></svg>'
      +       '</button>'
      +     '</span>'
      +     '<span class="pcard__avail">' + (p.available || '23403') + ' y. available</span>'
      +   '</a>'
      +   '<div class="pcard__body">'
      +     '<div class="pcard__head">'
      +       '<a class="pcard__name" href="' + href + '">' + esc(p.name) + '</a>'
      +       '<p class="pcard__meta">' + esc(p.desc || '') + '</p>'
      +       '<div class="pcard__rate">'
      +         '<span>' + (p.rating || 0).toFixed(1) + '</span>'
      +         '<span class="pcard__stars">' + ratingStarsHTML(p.rating) + '</span>'
      +         '<span>(' + (p.reviews || 0) + ')</span>'
      +       '</div>'
      +     '</div>'
      +     '<div class="pcard__controls">'
      +       '<div class="pcard__swatches">'
      +         '<button type="button" class="pcard__sw-arrow pcard__sw-arrow--prev" data-action="sw-prev" aria-label="Previous colours" hidden><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>'
      +         '<div class="pcard__sw-track">' + swatchListHTML(p) + '</div>'
      +         '<button type="button" class="pcard__sw-arrow pcard__sw-arrow--next" data-action="sw-next" aria-label="More colours"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>'
      +       '</div>'
      +       '<div class="pcard__length" data-length>'
      +         '<button type="button" class="pcard__length-btn" data-action="length-toggle" aria-haspopup="listbox" aria-expanded="false">'
      +           '<span class="pcard__price"><b>' + fmt(p.price) + '</b><small> /yd</small></span>'
      +           '<span class="pcard__length-sep">|</span>'
      +           '<span class="pcard__length-val">' + LENGTH_OPTIONS[0] + '</span>'
      +           '<svg class="pcard__length-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>'
      +         '</button>'
      +         '<div class="pcard__length-menu" role="listbox" hidden>' + lengthMenuHTML() + '</div>'
      +       '</div>'
      +       '<div class="pcard__qty">'
      +         '<button type="button" class="pcard__qty-btn" data-action="pcard-dec" aria-label="Decrease quantity">'
      +           '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>'
      +         '</button>'
      +         '<span class="pcard__qty-val"><b data-bind-card="qty">1</b> yd(s)</span>'
      +         '<button type="button" class="pcard__qty-btn" data-action="pcard-inc" aria-label="Increase quantity">'
      +           '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>'
      +         '</button>'
      +       '</div>'
      +     '</div>'
      +   '</div>'
      +   '<button type="button" class="pcard__add" data-action="add-to-cart" aria-label="Add ' + escAttr(p.name) + ' to bag">'
      +     '<span class="pcard__add-left">'
      +       '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>'
      +       '<span class="pcard__add-label">Add to Bag</span>'
      +       '<span class="pcard__add-label-sm" aria-hidden="true">Add</span>'
      +     '</span>'
      +     '<span class="pcard__add-price" data-bind-card="total">' + fmt(p.price) + '</span>'
      +   '</button>'
      + '</article>';
  }

  // ---------- ACTIONS ----------
  function getProduct(id) {
    var products = window.OCP_PRODUCTS || [];
    for (var i = 0; i < products.length; i++) if (products[i].id === id) return products[i];
    return null;
  }

  // Per-card quantity (stored on the .pcard element, reflected in the stepper + Add to Bag price)
  function cardQty(el) {
    var pc = el.classList && el.classList.contains('pcard') ? el : el.closest && el.closest('.pcard');
    if (!pc) return 1;
    return Math.max(1, parseInt(pc.getAttribute('data-qty'), 10) || 1);
  }
  var CARD_TIER_LABELS = ['1-4', '5-9', '10-19', '20-49', '50+']; // ranges only; the price suffix carries the (dynamic) unit
  function tierForCardQty(q) { q = parseInt(q, 10) || 1; return q >= 50 ? 4 : q >= 20 ? 3 : q >= 10 ? 2 : q >= 5 ? 1 : 0; }
  function cardTiers(pc) {
    var s = pc.getAttribute('data-tiers'); if (!s) return null;
    var a = s.split(',').map(function (x) { return parseFloat(x); });
    return a.length === 5 ? a : null;
  }
  function cardTierIds(pc) {
    var s = pc.getAttribute('data-tier-ids'); if (!s) return null;
    var a = s.split(',').map(function (x) { return (x || '').trim(); });
    return a.length === 5 ? a : null;
  }
  function cardResolvedTier(pc, tier) {
    var ids = cardTierIds(pc);
    if (!ids) return tier;
    var target = ids[tier] || ids[0];
    if (!target) return tier;
    var exact = pc.querySelector('.pcard__length-opt[data-tier-id="' + target + '"]');
    if (exact) return parseInt(exact.getAttribute('data-tier'), 10) || 0;
    for (var i = tier; i >= 0; i--) {
      if (ids[i] && ids[i] !== target) break;
      var fallback = pc.querySelector('.pcard__length-opt[data-tier="' + i + '"]');
      if (fallback) return i;
    }
    return tier;
  }
  function syncCardAddVariant(pc, tier) {
    var ids = cardTierIds(pc);
    var variantId = ids && (ids[tier] || ids[0]);
    var addButton = pc.querySelector('[data-action="add-to-cart"]');
    if (variantId) {
      pc.setAttribute('data-variant-id', variantId);
      if (addButton) addButton.setAttribute('data-variant-id', variantId);
    }
  }
  // Quantity drives the bulk tier: update per-yard price, the dropdown label, the line total, and
  // which tier row is active. Per-yard price comes from the tier table (data-tiers) when present.
  function setCardQty(pc, qty) {
    qty = Math.max(1, qty);
    pc.setAttribute('data-qty', qty);
    var tiers = cardTiers(pc);
    var tier = tierForCardQty(qty);
    var activeTier = cardResolvedTier(pc, tier);
    var price = tiers ? (tiers[tier] || tiers[0]) : (parseFloat(pc.getAttribute('data-price')) || 0);
    pc.setAttribute('data-price', price);
    syncCardAddVariant(pc, tier);
    var qtyEl = pc.querySelector('[data-bind-card="qty"]');
    var totalEl = pc.querySelector('[data-bind-card="total"]');
    var perYard = pc.querySelector('.pcard__price b');
    var lenVal = pc.querySelector('.pcard__length-val');
    if (qtyEl) qtyEl.textContent = qty;
    if (perYard) perYard.textContent = fmt(price);
    if (lenVal && tiers) {
      var activeOpt = pc.querySelector('.pcard__length-opt[data-tier="' + activeTier + '"] span');
      lenVal.textContent = activeOpt ? activeOpt.textContent : CARD_TIER_LABELS[tier];
    }
    if (totalEl) totalEl.textContent = fmt(price * qty);
    if (tiers) {
      $$('.pcard__length-opt', pc).forEach(function (o) {
        var on = o.getAttribute('data-tier') === String(activeTier);
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
  }
  function syncCardVariant(pc, swatch) {
    if (!pc || !swatch) return;
    var variantId = swatch.getAttribute('data-variant-id');
    var price = parseFloat(swatch.getAttribute('data-price')) || parseFloat(pc.getAttribute('data-price')) || 0;
    var priceHTML = swatch.getAttribute('data-price-html') || fmt(price);
    var url = swatch.getAttribute('data-url');
    var image = swatch.getAttribute('data-image');
    var available = swatch.getAttribute('data-available') !== 'false';
    var addButton = pc.querySelector('[data-action="add-to-cart"]');
    var priceEl = pc.querySelector('.pcard__price b');
    var media = pc.querySelector('.pcard__media');
    var name = pc.querySelector('.pcard__name');

    if (variantId) {
      pc.setAttribute('data-variant-id', variantId);
      if (addButton) addButton.setAttribute('data-variant-id', variantId);
    }
    pc.setAttribute('data-price', price);
    if (swatch.getAttribute('data-tier-ids')) pc.setAttribute('data-tier-ids', swatch.getAttribute('data-tier-ids'));
    // Reprice the bulk tiers for this colour/size using the real variant prices when Liquid exposed them.
    var tiers = cardTiers(pc);
    var swatchTiers = swatch.getAttribute('data-tiers');
    if (swatchTiers) {
      var nt = swatchTiers.split(',').map(function (t) { return parseFloat(t); });
      pc.setAttribute('data-tiers', nt.join(','));
      $$('.pcard__length-opt', pc).forEach(function (o, i) {
        var tierIndex = parseInt(o.getAttribute('data-tier'), 10) || 0;
        var pb = o.querySelector('[data-tier-price]');
        var ids = cardTierIds(pc);
        if (ids && ids[tierIndex]) o.setAttribute('data-tier-id', ids[tierIndex]);
        if (pb && nt[tierIndex] != null) pb.textContent = fmt(nt[tierIndex]);
      });
    } else if (tiers && tiers[0] > 0 && price > 0) {
      var ratioTiers = tiers.map(function (t) { return Math.round(price * (t / tiers[0]) * 100) / 100; });
      pc.setAttribute('data-tiers', ratioTiers.join(','));
      $$('.pcard__length-opt', pc).forEach(function (o) {
        var tierIndex = parseInt(o.getAttribute('data-tier'), 10) || 0;
        var pb = o.querySelector('[data-tier-price]');
        if (pb && ratioTiers[tierIndex] != null) pb.textContent = fmt(ratioTiers[tierIndex]);
      });
    }
    if (priceEl) priceEl.innerHTML = priceHTML;
    if (media && image) {
      // Keep the current product visible until the selected colour image is fully decoded. The pending
      // URL guard also prevents a slower earlier click from replacing a newer swatch selection.
      media.dataset.pendingImage = image;
      var nextImage = new Image();
      nextImage.decoding = 'async';
      var applyImage = function () {
        if (media.dataset.pendingImage !== image) return;
        media.style.backgroundImage = 'url("' + image + '")';
        delete media.dataset.pendingImage;
      };
      nextImage.onload = function () {
        if (nextImage.decode) nextImage.decode().then(applyImage).catch(applyImage);
        else applyImage();
      };
      nextImage.onerror = function () {
        if (media.dataset.pendingImage === image) delete media.dataset.pendingImage;
      };
      nextImage.src = image;
    }
    if (url) {
      if (media) media.setAttribute('href', url);
      if (name) name.setAttribute('href', url);
    }
    if (addButton) {
      // reflect the chosen colour's stock state (in stock / preorder / sold out) on the add button
      var st = swatch.getAttribute('data-state') || (available ? 'instock' : 'oos');
      addButton.classList.remove('is-instock', 'is-preorder', 'is-oos');
      addButton.classList.add('is-' + st);
      addButton.disabled = st === 'oos';
      // Both labels have to move together: CSS shows the short one on the narrow mobile card and the
      // full one elsewhere, so updating only the first span would leave a sold-out card reading "Add".
      var oosText = addButton.getAttribute('data-oos-label') || 'Sold out';
      var preText = addButton.getAttribute('data-preorder-label') || 'Pre-order';
      var label = addButton.querySelector('.pcard__add-label') || addButton.querySelector('.pcard__add-left span');
      if (label) label.textContent = st === 'oos' ? oosText
        : st === 'preorder' ? preText
        : (addButton.getAttribute('data-add-label') || 'Add to Bag');
      var labelSm = addButton.querySelector('.pcard__add-label-sm');
      if (labelSm) labelSm.textContent = st === 'oos' ? oosText
        : st === 'preorder' ? preText
        : (addButton.getAttribute('data-add-label-short') || 'Add');
    }
    // Purchase a Swatch follows the colour, as it did on the old site (scripts-global.liquid picked the
    // chosen colour's `option1 == 'swatch'` variant). A colour with no sample of its own keeps whatever
    // the button already pointed at rather than breaking the button.
    var swatchBuy = pc.querySelector('[data-action="pcard-swatch-buy"]');
    if (swatchBuy) {
      var sampleId = swatch.getAttribute('data-swatch-id');
      if (sampleId) {
        swatchBuy.setAttribute('data-variant-id', sampleId);
        var samplePrice = swatch.getAttribute('data-swatch-price');
        var spEl = swatchBuy.querySelector('[data-bind-card="swatch-price"]');
        if (spEl && samplePrice) spEl.textContent = samplePrice;
      }
    }
    setCardQty(pc, cardQty(pc));
  }

  // Background swatch warm-up (Review 09/07, All products #4): AFTER the page has loaded, quietly preload
  // the colour-swatch images for cards that are in (or near) the viewport, so switching colour is instant
  // with no empty flash. This never competes with the initial page load — it waits for window 'load' and
  // runs during idle time — and it only fetches cards the shopper can actually see; scrolling reveals more
  // and those warm up as they approach view. Each swatch image is fetched at most once (data-preloaded).
  function warmCardSwatches(card) {
    $$('.pcard__sw[data-image]', card).forEach(function (sw) {
      if (sw.getAttribute('data-preloaded') === '1') return;
      sw.setAttribute('data-preloaded', '1');
      var img = new Image();
      img.decoding = 'async';
      img.src = sw.getAttribute('data-image');
    });
  }
  function initSwatchPrewarm() {
    if (!('IntersectionObserver' in window)) return;
    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 200); };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var card = en.target;
        idle(function () { warmCardSwatches(card); });
      });
    }, { rootMargin: '200px' }); // start a touch before the card scrolls into view
    function observeAll() {
      $$('.pcard').forEach(function (c) { if (!c.__prewarm) { c.__prewarm = 1; io.observe(c); } });
    }
    observeAll();
    document.addEventListener('ocp:collection-swapped', observeAll); // re-observe AJAX-added cards
  }
  if (document.readyState === 'complete') initSwatchPrewarm();
  else window.addEventListener('load', initSwatchPrewarm);

  // Review #5 (item 13) / Review #7: the container tracks the ACTIVE panel's height with a smooth
  // min-height transition. The old approach locked to the TALLEST panel, which left a huge blank
  // scroll region under short tabs when the Description panel was long (client-reported overscroll).
  function stabilizeTabPanels(tabsId) {
    // Desktop-only: on mobile the panels stack in one column and need no height management.
    if (window.innerWidth < 821) return;
    if (!tabsId) return;
    var wrap = document.querySelector('[data-tab-panels="' + tabsId + '"]');
    if (!wrap) return;
    var active = null;
    $$('[data-tab-panel]', wrap).forEach(function (pn) { if (!pn.hidden) active = pn; });
    if (!active) return;
    wrap.style.transition = 'min-height .25s ease';
    wrap.style.minHeight = active.offsetHeight + 'px';
  }
  document.addEventListener('DOMContentLoaded', function () {
    $$('.pdp-tabs[id]').forEach(function (tabs) { stabilizeTabPanels(tabs.id); });
  });
  // If the window crosses into mobile width, release any reserved height.
  window.addEventListener('resize', function () {
    if (window.innerWidth < 821) {
      $$('.pdp-tab-panels').forEach(function (w) { w.style.minHeight = ''; });
    }
  });

  // ---------- CARD: length dropdown + swatch slider (enhance static markup) ----------
  function closeAllLengthMenus() {
    $$('.pcard__length-menu').forEach(function (m) { m.hidden = true; });
    $$('.pcard__length-btn[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  function updateSwatchArrows(sws) {
    var track = sws.querySelector('.pcard__sw-track');
    var prev = sws.querySelector('.pcard__sw-arrow--prev');
    var next = sws.querySelector('.pcard__sw-arrow--next');
    if (!track) return;
    var overflow = track.scrollWidth - track.clientWidth;
    if (overflow <= 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; return; }
    if (prev) prev.hidden = track.scrollLeft <= 2;
    if (next) next.hidden = track.scrollLeft >= overflow - 2;
  }
  function initCardSliders() {
    $$('.pcard__swatches').forEach(function (sws) {
      updateSwatchArrows(sws);
      var track = sws.querySelector('.pcard__sw-track');
      if (track && !track.__bound) {
        track.__bound = true;
        track.addEventListener('scroll', function () { updateSwatchArrows(sws); }, { passive: true });
      }
    });
  }

  // Mobile #4 — floating "back to top" arrow. Injected globally so every page (esp. long
  // Learning-Center / Conscious-Crafting pages) gets a quick jump to the top.
  function initBackToTop() {
    if (document.querySelector('.to-top')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    document.body.appendChild(btn);
    var toggle = function () {
      btn.classList.toggle('is-visible', window.pageYOffset > 600);
    };
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  }

  // Judge.me review widget (PDP). Judge.me fills #judgeme_product_reviews client-side, so watch it and
  // mirror the average rating into --ocp-jm-rating; ocp-styles-extra.css paints the star row from it.
  function initJudgemeWidget() {
    var host = document.getElementById('judgeme_product_reviews');
    if (!host || host.__ocpBound) return;
    host.__ocpBound = true;
    var sync = function () {
      var avg = host.querySelector('.jm-average-rating-display');
      if (!avg) return;
      var p = avg.querySelector('p');
      var n = p ? parseFloat(p.textContent) : NaN;
      if (isNaN(n)) return;
      n = Math.max(0, Math.min(5, n));
      if (avg.style.getPropertyValue('--ocp-jm-rating') !== String(n)) avg.style.setProperty('--ocp-jm-rating', String(n));
    };
    sync();
    new MutationObserver(sync).observe(host, { childList: true, subtree: true, characterData: true });
  }

  // Dual-thumb price range: keep the two range thumbs from crossing, paint the fill between them,
  // and mirror the values into the visible number inputs (which carry the real filter param names).
  function initPriceSliders() {
    $$('[data-price-filter]').forEach(function (box) {
      if (box.__bound) return;
      box.__bound = true;
      var minR = box.querySelector('[data-price-range="min"]');
      var maxR = box.querySelector('[data-price-range="max"]');
      var minI = box.querySelector('[data-price-input="min"]');
      var maxI = box.querySelector('[data-price-input="max"]');
      var minH = box.querySelector('[data-price-hidden="min"]');
      var maxH = box.querySelector('[data-price-hidden="max"]');
      var modeI = box.querySelector('[data-price-mode]');
      var fill = box.querySelector('[data-price-fill]');
      var max = parseFloat(box.getAttribute('data-pmax')) || 100;
      if (!minR || !maxR) return;
      function asNumber(v, fallback) {
        var n = parseFloat(v);
        return isNaN(n) ? fallback : n;
      }
      function moneyValue(v) {
        var n = parseFloat(v);
        if (isNaN(n)) return '';
        return (Math.round(n * 100) / 100).toString();
      }
      function syncHidden() {
        if (minH) minH.value = minI && minI.value !== '' ? moneyValue(minI.value) : '';
        if (maxH) {
          var maxVal = maxI && maxI.value !== '' ? asNumber(maxI.value, max) : max;
          maxH.value = maxVal >= max ? '' : moneyValue(maxVal);
        }
      }
      function clearPresets() {
        box.querySelectorAll('[data-price-preset-min]').forEach(function (preset) { preset.checked = false; });
        if (modeI) modeI.value = 'manual';
      }
      function applyPriceFilter() {
        var form = box.closest('[data-ocp-filter-form]');
        if (!form || form.closest('.sheet')) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
      function scheduleTypedCommit(delay) {
        clearTimeout(box.__priceTypingTimer);
        box.__priceTypingTimer = setTimeout(function () {
          syncHidden();
          applyPriceFilter();
        }, delay || 500);
      }
      function syncPresetsToFields() {
        var selected = Array.prototype.slice.call(box.querySelectorAll('[data-price-preset-min]:checked'));
        if (!selected.length) {
          if (minI) minI.value = '';
          if (maxI) maxI.value = '';
          if (minH) minH.value = '';
          if (maxH) maxH.value = '';
          minR.value = 0;
          maxR.value = max;
          if (modeI) modeI.value = '';
          return;
        }
        if (modeI) modeI.value = 'preset';
        var minVal = Infinity;
        var maxVal = -Infinity;
        var hasOpenMin = false;
        var hasOpenMax = false;
        selected.forEach(function (preset) {
          var minAttr = preset.getAttribute('data-price-preset-min');
          var maxAttr = preset.getAttribute('data-price-preset-max');
          if (minAttr === '') hasOpenMin = true;
          else minVal = Math.min(minVal, asNumber(minAttr, 0));
          if (maxAttr === '') hasOpenMax = true;
          else maxVal = Math.max(maxVal, asNumber(maxAttr, max));
        });
        var nextMin = hasOpenMin || minVal === Infinity || minVal <= 0 ? '' : moneyValue(minVal);
        var nextMax = hasOpenMax || maxVal === -Infinity || maxVal >= max ? '' : moneyValue(maxVal);
        if (minI) minI.value = nextMin;
        if (maxI) maxI.value = nextMax;
        if (minH) minH.value = nextMin;
        if (maxH) maxH.value = nextMax;
        minR.value = nextMin || 0;
        maxR.value = nextMax || max;
      }
      function syncPresetChecksFromMode() {
        var params = new URLSearchParams(window.location.search);
        var mode = params.get('ocp_price_mode') || '';
        if (modeI) modeI.value = mode;
        if (mode === 'manual') {
          clearPresets();
          return;
        }
        if (mode !== 'preset') return;
        var curMin = minI && minI.value !== '' ? moneyValue(minI.value) : '';
        var curMax = maxI && maxI.value !== '' ? moneyValue(maxI.value) : '';
        // Multi-select restore: a preset is checked when its whole bucket sits inside the applied
        // span, so "$5-$10" + "$10-$15" -> 5..15 re-checks both after the AJAX swap.
        if (curMin === '' && curMax === '') return;
        var spanLo = curMin === '' ? -Infinity : parseFloat(curMin);
        var spanHi = curMax === '' ? Infinity : parseFloat(curMax);
        box.querySelectorAll('[data-price-preset-min]').forEach(function (preset) {
          var pMin = preset.getAttribute('data-price-preset-min');
          var pMax = preset.getAttribute('data-price-preset-max');
          var bucketLo = pMin === '' ? -Infinity : parseFloat(moneyValue(pMin));
          var bucketHi = pMax === '' ? Infinity : parseFloat(moneyValue(pMax));
          preset.checked = bucketLo >= spanLo && bucketHi <= spanHi;
        });
      }
      function paint() {
        var a = Math.min(+minR.value, +maxR.value), b = Math.max(+minR.value, +maxR.value);
        if (fill) { fill.style.left = (a / max * 100) + '%'; fill.style.right = (100 - b / max * 100) + '%'; }
      }
      function clampThumbs(lead) {
        if (+minR.value > +maxR.value) {
          if (lead === 'min') maxR.value = minR.value; else minR.value = maxR.value;
        }
      }
      minR.addEventListener('input', function () { clampThumbs('min'); clearPresets(); if (minI) minI.value = moneyValue(minR.value); syncHidden(); paint(); });
      maxR.addEventListener('input', function () { clampThumbs('max'); clearPresets(); if (maxI) maxI.value = (+maxR.value >= max ? '' : moneyValue(maxR.value)); syncHidden(); paint(); });
      // committing a thumb fires a change on the hidden Shopify input so the existing filter listener applies it
      function commit(e) {
        if (e && e.stopPropagation) e.stopPropagation();
        syncHidden();
        applyPriceFilter();
      }
      minR.addEventListener('change', commit);
      maxR.addEventListener('change', commit);
      // typing in the number fields moves the thumbs back
      if (minI) minI.addEventListener('input', function () { clearPresets(); minR.value = minI.value || 0; clampThumbs('min'); syncHidden(); paint(); scheduleTypedCommit(); });
      if (maxI) maxI.addEventListener('input', function () { clearPresets(); maxR.value = maxI.value || max; clampThumbs('max'); syncHidden(); paint(); scheduleTypedCommit(); });
      if (minI) minI.addEventListener('change', commit);
      if (maxI) maxI.addEventListener('change', commit);
      if (minI && minI.value !== '') minI.value = moneyValue(minI.value);
      if (maxI && maxI.value !== '') maxI.value = moneyValue(maxI.value);
      syncPresetChecksFromMode();
      box.querySelectorAll('[data-price-preset-min]').forEach(function (preset) {
        preset.addEventListener('change', function (e) {
          if (e && e.stopPropagation) e.stopPropagation();
          // Presets are MULTI-select: checked boxes merge into one
          // span (min of mins .. max of maxes), which Shopify's single gte/lte range can express.
          // Known edge: "Less than $5" + "$30 +" spans everything, i.e. no price constraint.
          syncPresetsToFields();
          clampThumbs('max');
          paint();
          scheduleTypedCommit(1200);
        });
      });
      syncHidden();
      paint();
    });
  }

  // PDP thumbnail strip is a horizontal slider on mobile; toggle prev/next arrows by scroll position
  // (left arrow only when scrolled right, right arrow only when more remains). Mirrors updateSwatchArrows.
  function initPdpThumbSlider() {
    var track = document.querySelector('[data-pdp-thumbs]');
    if (!track) return;
    var wrap = track.closest('.pdp__thumbs-wrap');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-pdp-thumbs-prev]');
    var next = wrap.querySelector('[data-pdp-thumbs-next]');
    function update() {
      var overflow = track.scrollWidth - track.clientWidth;
      if (overflow <= 2) { if (prev) prev.classList.add('is-off'); if (next) next.classList.add('is-off'); return; } // desktop grid / few thumbs
      if (prev) prev.classList.toggle('is-off', track.scrollLeft <= 8);
      if (next) next.classList.toggle('is-off', track.scrollLeft >= overflow - 8);
    }
    function move(dir) {
      var max = track.scrollWidth - track.clientWidth;
      var startL = track.scrollLeft;
      var target = Math.max(0, Math.min(max, startL + dir * Math.max(track.clientWidth * 0.8, 160)));
      var delta = target - startL;
      if (Math.abs(delta) < 1) return;
      // Tween scrollLeft ourselves — JS/CSS smooth-scroll is unreliable on scroll-snap tracks. Disable snap
      // during the tween so it doesn't yank each frame, then restore it once we land near a boundary.
      var prevSnap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      var t0 = null;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / 320);
        track.scrollLeft = startL + delta * (1 - Math.pow(1 - p, 3)); // easeOutCubic
        if (p < 1) { requestAnimationFrame(step); } else { track.style.scrollSnapType = prevSnap; update(); }
      }
      requestAnimationFrame(step);
    }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); move(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); move(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(window.__ocpThumbTimer); window.__ocpThumbTimer = setTimeout(update, 150); });
    update();
  }

  function setPdpImage(pdp, index) {
    if (!pdp) return;
    var idx = Math.max(0, parseInt(index, 10) || 0);
    var thumb = pdp.querySelector('[data-pdp-index="' + idx + '"]');
    if (thumb) swapPdpHero(pdp, thumb.getAttribute('data-pdp-image'));
  }

  // Hero swaps go through a probe Image(): cached URLs swap instantly, uncached ones show a
  // spinner (.pdp-hero.is-swapping) instead of silently keeping the previous color's photo.
  // The matching thumbnail/dot is highlighted so the gallery follows the swatch selection.
  var heroSwapToken = 0;
  function swapPdpHero(pdp, url) {
    if (!pdp || !url) return;
    var hero = pdp.querySelector('[data-bind-pdp-image]');
    if (!hero) return;
    // Reverse any active video: show the photo hero, hide all video slots.
    var photo = pdp.querySelector('.pdp-hero__photo');
    if (photo) photo.hidden = false;
    $$('.pdp-hero__video', pdp).forEach(function (el) { el.hidden = true; });
    syncPdpSelection(pdp, url);
    var heroBox = pdp.querySelector('.pdp-hero');
    var token = ++heroSwapToken;
    var probe = new Image();
    probe.onload = probe.onerror = function () {
      if (token !== heroSwapToken) return;
      hero.src = url;
      if (heroBox) heroBox.classList.remove('is-swapping');
    };
    probe.src = url;
    if (!probe.complete && heroBox) heroBox.classList.add('is-swapping');
  }
  function syncPdpSelection(pdp, url) {
    var match = $$('.pdp-thumb[data-pdp-image]', pdp).filter(function (el) {
      return el.getAttribute('data-pdp-image') === url;
    })[0];
    if (!match) return;
    var idx = match.getAttribute('data-pdp-index');
    $$('.pdp-thumb', pdp).forEach(function (el) { el.classList.toggle('is-active', el === match); });
    $$('[data-pdp-dot]', pdp).forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-pdp-dot') === String(idx));
    });
    if (match.scrollIntoView) match.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }

  // After the page settles, warm every swatch/thumbnail image one at a time so color clicks
  // swap instantly instead of streaming the full-size photo on demand.
  function preloadPdpImages() {
    var pdp = document.querySelector('.pdp');
    if (!pdp) return;
    var seen = {};
    var urls = [];
    $$('.pdp-swatch[data-image], .pdp-thumb[data-pdp-image]', pdp).forEach(function (el) {
      var u = el.getAttribute('data-image') || el.getAttribute('data-pdp-image');
      if (u && !seen[u]) { seen[u] = 1; urls.push(u); }
    });
    var i = 0;
    (function next() {
      if (i >= urls.length) return;
      var im = new Image();
      im.onload = im.onerror = function () { setTimeout(next, 60); };
      im.src = urls[i++];
    })();
  }
  window.addEventListener('load', function () { setTimeout(preloadPdpImages, 800); });

  function setPdpVideo(pdp, id) {
    if (!pdp || !id) return;
    var photo = pdp.querySelector('.pdp-hero__photo');
    if (photo) photo.hidden = true;
    $$('.pdp-hero__video', pdp).forEach(function (el) {
      el.hidden = el.getAttribute('data-pdp-video-slot') !== String(id);
    });
    $$('.pdp-thumb', pdp).forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-pdp-video') === String(id));
    });
  }

  function fetchShopifyCart() {
    var cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) ? Theme.routes.cart_url : '/cart';
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      return response.json();
    });
  }

  function dispatchShopifyCartUpdate(cart, sections, itemCount, variantId, productId) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart || {},
        sourceId: 'ocp-pcard',
        data: {
          source: 'ocp-pcard',
          itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : itemCount,
          productId: productId,
          variantId: variantId,
          sections: sections || {}
        }
      }
    }));
  }

  function addShopifyVariantToCart(pc, trigger, qtyOverride) {
    var routes = window.Theme && Theme.routes;
    var variantId = trigger.getAttribute('data-variant-id') || pc.getAttribute('data-variant-id');
    if (!routes || !routes.cart_add_url || !variantId) return false;

    var qty = Math.max(1, parseInt(qtyOverride, 10) || cardQty(pc));
    var sectionIds = [];
    $$('cart-items-component').forEach(function (item) {
      if (item.dataset && item.dataset.sectionId) sectionIds.push(item.dataset.sectionId);
    });
    var payload = { items: [{ id: Number(variantId), quantity: qty }] };
    if (sectionIds.length) payload.sections = sectionIds.join(',');

    trigger.disabled = true;
    trigger.setAttribute('aria-busy', 'true');
    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) throw new Error(response.description || response.message || 'Cart add failed');
        return fetchShopifyCart().then(function (cart) {
          dispatchShopifyCartUpdate(cart, response.sections, qty, String(variantId), pc.getAttribute('data-product-id'));
        });
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        trigger.removeAttribute('aria-busy');
        if (pc.getAttribute('data-variant-id') === String(variantId)) trigger.disabled = false;
      });
    return true;
  }

  function addToCart(id, qty) {
    var p = getProduct(id);
    if (!p) return;
    qty = Math.max(1, qty || 1);
    var cart = getCart();
    var existing = null;
    for (var i = 0; i < cart.length; i++) if (cart[i].id === id) { existing = cart[i]; break; }
    if (existing) existing.qty = (existing.qty || 1) + qty;
    else cart.push({ id: p.id, name: p.name, desc: p.desc, price: p.price, swatch: p.swatch, image: p.image || (p.thumbs && p.thumbs[0]) || '', color: (p.colors && p.colors[0]) || '', qty: qty });
    setCart(cart);
    openCart();
  }

  function removeFromCart(id) {
    setCart(getCart().filter(function (i) { return i.id !== id; }));
  }
  function changeQty(id, delta) {
    var cart = getCart();
    for (var i = 0; i < cart.length; i++) {
      if (cart[i].id === id) {
        cart[i].qty = Math.max(1, (cart[i].qty || 1) + delta);
        break;
      }
    }
    setCart(cart);
  }

  function toggleWish(id) {
    var wish = getWish();
    var idx = wish.indexOf(id);
    if (idx >= 0) wish.splice(idx, 1);
    else wish.push(id);
    setWish(wish);
  }

  // ---------- DRAWERS ----------
  function setMenuExpanded(open) {
    $$('[data-action="toggle-menu"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function setOpen(el, open) {
    if (!el) return;
    el.classList.toggle('is-open', open);
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('is-locked', !!document.querySelector('.drawer.is-open, .cart-drawer.is-open, .cart-popup.is-open'));
    if (el.id === 'drawer') setMenuExpanded(open);
  }
  function openMenu()  { setOpen(document.getElementById('drawer'), true); }
  function closeMenu() { setOpen(document.getElementById('drawer'), false); }

  // Cart shell: "popup" (default, centered modal) or "drawer" (side panel) — a theme setting.
  function cartStyle() { return document.body.getAttribute('data-cart-style') === 'drawer' ? 'drawer' : 'popup'; }
  function openCart() {
    buildCartPopup();
    renderCart();
    setOpen(document.getElementById(cartStyle() === 'popup' ? 'cart-popup' : 'cart-drawer'), true);
  }
  function closeCart() {
    setOpen(document.getElementById('cart-popup'), false);
    setOpen(document.getElementById('cart-drawer'), false);
  }

  // Inject the cart popup shell once (single source of truth — maps to a Shopify snippet later).
  // Reuses the same data-bind hooks + renderCart() table variant as the cart page & drawer.
  function buildCartPopup() {
    if (document.getElementById('cart-popup')) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = ''
      + '<div class="cart-popup" id="cart-popup" aria-hidden="true" role="dialog" aria-modal="true" aria-label="Shopping bag">'
      +   '<div class="cart-popup__backdrop" data-action="close-cart"></div>'
      +   '<div class="cart-popup__panel" role="document">'
      +     '<header class="cart-popup__head">'
      +       '<h2 class="cart-popup__title">Your Shopping Bag</h2>'
      +       '<button type="button" class="cart-popup__close" data-action="close-cart" aria-label="Close bag"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
      +     '</header>'
      +     '<div class="cart-popup__bar">'
      +       '<div class="cart-popup__ship"><span class="cart-popup__ship-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 13l2-7h11l3 4h2v6h-3"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg></span><p class="cart-popup__ship-msg" data-bind="cart-ship-msg">Add <strong>$75.00</strong> more to unlock <strong>FREE delivery</strong></p></div>'
      +       '<form class="cart-popup__promo" data-action="apply-promo"><label class="visually-hidden" for="cart-popup-promo">Promo code</label><input id="cart-popup-promo" type="text" name="promo" placeholder="Type here promocode..."><button type="submit" class="cart-popup__apply">Apply</button></form>'
      +     '</div>'
      +     '<p class="cart-popup__promo-msg" data-bind="promo-msg" aria-live="polite"></p>'
      +     '<div class="cart-discounts cart-popup__discounts" data-bind="cart-discounts" aria-label="Applied discounts" hidden></div>'
      +     '<div class="cart-popup__scroll">'
      +       '<div class="cart-table cart-popup__table">'
      +         '<div class="cart-table__head" aria-hidden="true"><span class="cart-table__col">Product</span><span class="cart-table__col cart-table__col--price">Price</span><span class="cart-table__col cart-table__col--qty">QTY</span><span class="cart-table__col cart-table__col--total">Total</span><span class="cart-table__col"></span></div>'
      +         '<div class="cart-table__body" data-bind="cart-body" data-cart-variant="table"><p class="cart-table__empty">Your bag is empty.</p></div>'
      +       '</div>'
      +       '<div class="cart-popup__instructions"><h3>Special Instructions</h3><textarea placeholder="Type here comment to the order..." rows="2" data-action="cart-comment" aria-label="Special instructions"></textarea></div>'
      +       '<section class="cart-popup__recs" data-bind="cart-upsell" hidden aria-labelledby="cart-popup-recs-title"><h3 id="cart-popup-recs-title">Complete the Look</h3><div class="cart-popup__recs-rail" data-bind="cart-upsell-list"></div></section>'
      +     '</div>'
      // No terms line here: checkout presents terms on the next step, so repeating it under the
      // Express Checkout button was redundant. The cart page sidebar still carries one.
      +     '<footer class="cart-popup__foot">'
      +       '<div class="cart-popup__actions cart-popup__actions--single">'
      +         '<button type="button" class="cart-popup__checkout" data-action="checkout"><span>Express Checkout</span><span class="cart-popup__checkout-meta">( <b data-bind="cart-item-count">0</b> items | <b data-bind="cart-total">$0.00</b> )</span></button>'
      +       '</div>'
      +     '</footer>'
      +   '</div>'
      + '</div>';
    document.body.appendChild(wrap.firstChild);
  }

  // ---------- DELEGATED CLICKS ----------
  document.addEventListener('click', function (e) {
    // Close any open length dropdown when clicking outside of it
    if (!e.target.closest('[data-length]')) closeAllLengthMenus();
    var t = e.target.closest('[data-action]');
    if (!t) return;
    var action = t.getAttribute('data-action');

    if (action === 'toggle-menu') {
      e.preventDefault();
      // Desktop (>820px): the MENU button is a hover mega-dropdown — don't open the mobile drawer.
      if (window.matchMedia('(min-width: 821px)').matches && t.closest('.nav__menu-wrap--has-dropdown')) return;
      var drawer = document.getElementById('drawer');
      setOpen(drawer, !(drawer && drawer.classList.contains('is-open')));
      return;
    }
    if (action === 'close-menu')  { e.preventDefault(); closeMenu(); return; }
    if (action === 'open-cart')   { e.preventDefault(); openCart(); return; }
    if (action === 'close-cart')  { e.preventDefault(); closeCart(); return; }
    if (action === 'open-search') {
      e.preventDefault();
      openMenu();
      setTimeout(function () {
        var inp = document.querySelector('.drawer__search input');
        if (inp) inp.focus();
      }, 220);
      return;
    }

    if (action === 'toggle-wish') {
      e.preventDefault();
      var card = t.closest('[data-product-handle], [data-product-id]');
      if (card) toggleWish(wishKey(card));
      return;
    }
    if (action === 'add-to-cart') {
      e.preventDefault();
      var c = t.closest('[data-product-id]');
      if (c && !addShopifyVariantToCart(c, t)) addToCart(c.getAttribute('data-product-id'), cardQty(c));
      return;
    }
    if (action === 'pcard-inc' || action === 'pcard-dec') {
      e.preventDefault();
      var pc = t.closest('.pcard');
      if (pc) setCardQty(pc, cardQty(pc) + (action === 'pcard-inc' ? 1 : -1));
      return;
    }
    if (action === 'sw-prev' || action === 'sw-next') {
      e.preventDefault();
      var sws = t.closest('.pcard__swatches');
      var track = sws && sws.querySelector('.pcard__sw-track');
      if (track) {
        track.scrollBy({ left: (action === 'sw-next' ? 1 : -1) * 132, behavior: 'smooth' });
        setTimeout(function () { updateSwatchArrows(sws); }, 320);
      }
      return;
    }
    if (action === 'sw-select') {
      e.preventDefault();
      var grp = t.closest('.pcard__sw-track');
      if (grp) $$('.pcard__sw', grp).forEach(function (b) { b.classList.toggle('is-active', b === t); });
      syncCardVariant(t.closest('.pcard'), t);
      return;
    }
    if (action === 'length-toggle') {
      e.preventDefault();
      var wrap = t.closest('[data-length]');
      var menu = wrap && wrap.querySelector('.pcard__length-menu');
      var willOpen = menu && menu.hidden;
      closeAllLengthMenus();
      if (willOpen) { menu.hidden = false; t.setAttribute('aria-expanded', 'true'); }
      return;
    }
    if (action === 'length-pick') {
      e.preventDefault();
      var pcard = t.closest('.pcard');
      var min = parseInt(t.getAttribute('data-min'), 10) || 1;
      if (pcard) setCardQty(pcard, min);
      closeAllLengthMenus();
      return;
    }
    if (action === 'seg-select') {
      e.preventDefault();
      var seg = t.closest('.seg');
      if (seg) $$('.seg__btn', seg).forEach(function (b) { b.classList.toggle('is-active', b === t); });
      renderAllProducts();
      return;
    }
    if (action === 'cart-remove' || action === 'cart-inc' || action === 'cart-dec') {
      var line = t.closest('[data-id]');
      if (!line) return;
      var id = line.getAttribute('data-id');
      if (action === 'cart-remove') removeFromCart(id);
      if (action === 'cart-inc') changeQty(id, +1);
      if (action === 'cart-dec') changeQty(id, -1);
      return;
    }
    if (action === 'tab') {
      e.preventDefault();
      var tabs = t.parentNode;
      stabilizeTabPanels(tabs.id);
      $$('[data-action="tab"]', tabs).forEach(function (b) { b.classList.remove('is-active'); });
      t.classList.add('is-active');
      var name = t.getAttribute('data-tab');
      var panel = document.querySelector('[data-tab-panels="' + tabs.id + '"]');
      if (panel) {
        $$('[data-tab-panel]', panel).forEach(function (pn) {
          pn.hidden = pn.getAttribute('data-tab-panel') !== name;
        });
      }
      // Re-measure now that the new panel is visible: min-height glides old -> new instead of
      // holding the tallest panel's height (Review #7 overscroll) or snapping (Review #5 jump).
      stabilizeTabPanels(tabs.id);
      return;
    }
    if (action === 'read-more') {
      // PDP tagline "Read more" → open the Description tab and scroll to it (reuses the tab handler).
      e.preventDefault();
      var tabsId = t.getAttribute('data-tabs');
      var tabsEl = tabsId ? document.getElementById(tabsId) : document.querySelector('.pdp-tabs');
      if (tabsEl) {
        var descBtn = tabsEl.querySelector('[data-action="tab"][data-tab="description"]');
        if (descBtn) descBtn.click();
        tabsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    if (action === 'scroll-prev' || action === 'scroll-next') {
      e.preventDefault();
      var target = document.getElementById(t.getAttribute('data-target'));
      if (!target) return;
      var dir = action === 'scroll-prev' ? -1 : 1;
      moveRail(target, dir);
      return;
    }
    if (action === 'faq-toggle') {
      e.preventDefault();
      var item = t.closest('.faq-item');
      if (item) item.classList.toggle('is-open');
      return;
    }
    if (action === 'open-filters')  { e.preventDefault(); openSheet(document.getElementById('filters-sheet')); return; }
    if (action === 'close-filters') { e.preventDefault(); closeSheet(document.getElementById('filters-sheet')); return; }
    if (action === 'apply-filters') { e.preventDefault(); closeSheet(document.getElementById('filters-sheet')); return; }
    if (action === 'open-sort')     { e.preventDefault(); openSheet(document.getElementById('sort-sheet')); return; }
    if (action === 'close-sort')    { e.preventDefault(); closeSheet(document.getElementById('sort-sheet')); return; }
    if (action === 'clear-filters') { e.preventDefault(); clearAllFilters(); return; }
    if (action === 'remove-filter') {
      e.preventDefault();
      removeFilter(t.getAttribute('data-filter'), t.getAttribute('data-value'));
      return;
    }
    if (action === 'toggle-filters-collapse') {
      e.preventDefault();
      var f = document.getElementById('filters');
      if (f) f.classList.toggle('is-collapsed');
      return;
    }
  });

  document.addEventListener('submit', function (e) {
    if (REAL_CART) return; // ocp-cart-shopify.js handles promo submit via the real Cart AJAX API
    var t = e.target;
    var action = t.getAttribute && t.getAttribute('data-action');
    if (action === 'apply-promo') {
      e.preventDefault();
      var input = t.querySelector('input[name="promo"]');
      applyPromo(input ? input.value : '');
      return;
    }
  });

  document.addEventListener('input', function (e) {
    if (REAL_CART) return; // the note is debounced to the real cart (cart.note) by ocp-cart-shopify.js
    var t = e.target;
    if (t.matches && t.matches('textarea[data-action="cart-comment"]')) {
      writeComment(t.value);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeSheet(document.getElementById('filters-sheet'));
    closeSheet(document.getElementById('sort-sheet'));
    closeCart();
    closeMenu();
  });

  // ---------- PDP IMAGE ZOOM (custom lightbox) ----------
  // The hero wrapper carries [data-pdp-zoom] (role=button, tabindex=0). Click or Enter/Space opens a
  // fullscreen <dialog class="pdp-zoom"> showing the CURRENT hero image — the live [data-bind-pdp-image]
  // src, which is already requested at 1200w. Closes on Esc (native <dialog> cancel), backdrop click,
  // or the × button. Intentionally NOT Horizon's zoom-dialog.js (incompatible with the OCP custom PDP).
  var ocpZoomDialog = null;
  function ocpGetZoomDialog() {
    if (ocpZoomDialog) return ocpZoomDialog;
    var d = document.createElement('dialog');
    d.className = 'pdp-zoom';
    d.innerHTML =
      '<button type="button" class="pdp-zoom__close" data-pdp-zoom-close aria-label="Close">'
      + '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>'
      + '</button>'
      + '<img class="pdp-zoom__img" alt="" decoding="async">';
    // Backdrop (the dialog box itself) or × button closes; clicks on the image itself do not.
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-pdp-zoom-close]')) d.close();
    });
    document.body.appendChild(d);
    ocpZoomDialog = d;
    return d;
  }
  function ocpOpenZoom(trigger) {
    var hero = (trigger.querySelector && trigger.querySelector('[data-bind-pdp-image]'))
      || document.querySelector('.pdp-hero__photo [data-bind-pdp-image]')
      || document.querySelector('[data-bind-pdp-image]');
    if (!hero || !hero.getAttribute('src')) return;
    var d = ocpGetZoomDialog();
    var img = d.querySelector('.pdp-zoom__img');
    img.src = hero.getAttribute('src');
    img.alt = hero.getAttribute('alt') || '';
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
  }
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-pdp-zoom]');
    if (z) { e.preventDefault(); ocpOpenZoom(z); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var z = e.target.closest && e.target.closest('[data-pdp-zoom]');
    if (z) { e.preventDefault(); ocpOpenZoom(z); }
  });

  // Show/hide a rail's prev/next arrows by scroll position: both hidden when the rail can't scroll;
  // otherwise hide "prev" at the start (nothing on the left) and "next" at the end. Uses visibility
  // (not display) for the edge case so the remaining arrow keeps its position.
  function updateRailArrows() {
    // Mobile (≤1100px) uses circular rails — show BOTH arrows whenever the rail can move.
    // Desktop keeps the original edge-aware behavior (hide prev at start, next at end).
    var isMobile = window.matchMedia('(max-width: 1100px)').matches;
    $$('[data-action="scroll-prev"], [data-action="scroll-next"]').forEach(function (btn) {
      var id = btn.getAttribute('data-target');
      if (!id) return;
      var t = document.getElementById(id);
      if (isMobile) {
        var canMove = t && ((t.scrollWidth - t.clientWidth) > 4 || t.children.length >= 2);
        btn.style.display = canMove ? '' : 'none';
        btn.style.visibility = '';
        btn.style.pointerEvents = '';
        btn.disabled = !canMove;
        btn.setAttribute('aria-disabled', canMove ? 'false' : 'true');
        return;
      }
      var max = t ? (t.scrollWidth - t.clientWidth) : 0;
      if (!t || max <= 4) {
        btn.style.display = 'none';
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        return;
      }
      btn.style.display = '';
      var isPrev = btn.getAttribute('data-action') === 'scroll-prev';
      var show = isPrev ? (t.scrollLeft > 4) : (t.scrollLeft < max - 4);
      btn.style.visibility = show ? '' : 'hidden';
      btn.style.pointerEvents = show ? '' : 'none';
      btn.disabled = !show;
      btn.setAttribute('aria-disabled', show ? 'false' : 'true');
    });
  }

  // Bind a scroll listener (once per rail) so the arrows update their start/end state as you scroll.
  function bindRailScroll() {
    var seen = {};
    $$('[data-action="scroll-prev"], [data-action="scroll-next"]').forEach(function (btn) {
      var id = btn.getAttribute('data-target');
      if (!id || seen[id]) return;
      seen[id] = 1;
      var t = document.getElementById(id);
      if (t && !t.__railScrollBound) {
        t.__railScrollBound = true;
        t.addEventListener('scroll', function () { clearTimeout(t.__railST); t.__railST = setTimeout(updateRailArrows, 60); }, { passive: true });
      }
    });
  }

  function moveRail(target, dir) {
    var maxScroll = target.scrollWidth - target.clientWidth;
    var isMobile = window.matchMedia('(max-width: 1100px)').matches;
    if (maxScroll > 2) {
      if (isMobile) {
        // Circular (mobile): at the far end "next" wraps to the start; at the start "prev" wraps to
        // the end — so both arrows always do something (never a dead end).
        var step = Math.min(target.clientWidth, 600);
        var next;
        if (dir > 0) next = (target.scrollLeft >= maxScroll - 4) ? 0 : Math.min(maxScroll, target.scrollLeft + step);
        else next = (target.scrollLeft <= 4) ? maxScroll : Math.max(0, target.scrollLeft - step);
        target.scrollTo({ left: next, behavior: 'smooth' });
        return;
      }
      // Desktop: clamp at the edges (original edge-aware behavior).
      var amount = dir * Math.min(target.clientWidth, 600);
      var nextD = Math.max(0, Math.min(maxScroll, target.scrollLeft + amount));
      target.scrollTo({ left: nextD, behavior: 'smooth' });
      return;
    }
    var items = Array.prototype.slice.call(target.children).filter(function (el) {
      return el.nodeType === 1;
    });
    if (items.length < 2) return;
    if (dir > 0) target.appendChild(items[0]);
    else target.insertBefore(items[items.length - 1], items[0]);
  }

  // ---------- FORMS ----------
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-action]');
    if (!form) return;
    var action = form.getAttribute('data-action');

    if (action === 'newsletter') {
      e.preventDefault();
      bind('newsletter-msg', 'Thank you — check your inbox for 10% off.');
      form.reset();
      return;
    }
    if (action === 'search-form') {
      e.preventDefault();
      var q = (form.q && form.q.value || '').trim();
      if (q) location.href = 'all-products.html?q=' + encodeURIComponent(q);
      return;
    }
    if (action === 'contact') {
      e.preventDefault();
      bind('contact-msg', 'Thanks — we\'ll be in touch shortly.');
      form.reset();
      return;
    }
  });

  // ---------- KEYBOARD ----------
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenu();
      closeCart();
    }
  });

  // ---------- PDP VARIANT PICKER (server-rendered ocp-product.liquid) ----------
  // Data-driven from the embedded variant JSON. Runs the colour-swatch + auto-by-quantity
  // bulk-pricing model (matches production): resolves the cart variant as (colour x qty-tier),
  // re-prices the bulk table per colour, swaps the hero image on colour change, drives the
  // Purchase-Swatch button, and keeps ?variant= in the URL in sync via history.replaceState
  // (Shopify's deep-link convention — same contract as option_selection.js / variant-picker.js,
  // so Google Merchant Center feeds and shared links land on the right variant).
  function initPdpPicker() {
    var pdp = document.querySelector('.pdp');
    if (!pdp) return;
    var dataEl = pdp.querySelector('[data-pdp-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var V = (data && data.variants) || [];
    if (!V.length) return;

    var hasColor = !!data.hasColor;
    var hasTiers = !!data.hasTiers;
    var colorPos = data.colorPos || 0;
    var tierPos = data.tierPos || 1;
    var qInput = pdp.querySelector('#pdp-qty');
    var addBtn = pdp.querySelector('[data-action="pdp-add"]');
    var priceEl = pdp.querySelector('[data-bind-pdp-price]');
    var heroImg = pdp.querySelector('[data-bind-pdp-image]');
    var addLabel = (addBtn && addBtn.getAttribute('data-add-label')) || 'Add to Bag';
    var TIER_MIN = [1, 5, 10, 20, 50];

    function money(c) { return '$' + (Math.round(Number(c) || 0) / 100).toFixed(2); }
    function optVal(v, pos) { return pos === 1 ? v.o1 : pos === 2 ? v.o2 : pos === 3 ? v.o3 : null; }
    function colorOf(v) { return hasColor ? optVal(v, colorPos) : null; }
    function tierIndex(o) {
      var s = (o || '').toLowerCase();
      if (s.indexOf('swatch') >= 0 || s.indexOf('sample') >= 0) return -1;
      if (s.indexOf('50+') >= 0) return 4;
      if (s.indexOf('20+') >= 0 || s.indexOf('20-49') >= 0) return 3;
      if (s.indexOf('10+') >= 0 || s.indexOf('10-19') >= 0) return 2;
      if (s.indexOf('5+') >= 0 || s.indexOf('5-9') >= 0) return 1;
      return 0;
    }
    function tierOf(v) { return tierIndex(optVal(v, tierPos)); }
    function tierForQty(q) { q = parseInt(q, 10) || 1; return q >= 50 ? 4 : q >= 20 ? 3 : q >= 10 ? 2 : q >= 5 ? 1 : 0; }
    function pool(color) { return hasColor ? V.filter(function (v) { return colorOf(v) === color; }) : V.slice(); }
    function resolve(color, t) {
      var p = pool(color);
      var ex = p.filter(function (v) { return tierOf(v) === t; })[0];
      if (ex) return ex;
      for (var i = t - 1; i >= 0; i--) {
        var f = p.filter(function (v) { return tierOf(v) === i; })[0];
        if (f) return f;
      }
      return p.filter(function (v) { return tierOf(v) >= 0; })[0] || p[0];
    }
    function swatchVariant(color) { return pool(color).filter(function (v) { return tierOf(v) === -1; })[0]; }
    function displayTierFor(color, t) {
      var v = resolve(color, t);
      var rows = $$('.bulk-pricing label[data-bulk-qty]', pdp);
      if (v) {
        var matching = rows.filter(function (row) { return row.getAttribute('data-variant-id') === String(v.id); })[0];
        if (matching) return parseInt(matching.getAttribute('data-tier'), 10) || 0;
      }
      for (var i = t; i >= 0; i--) {
        var fallback = rows.filter(function (row) { return row.getAttribute('data-tier') === String(i); })[0];
        if (fallback) return i;
      }
      return t;
    }

    var state = { color: null, qty: 1 };
    var urlVariant = null;
    try { urlVariant = new URLSearchParams(window.location.search).get('variant'); } catch (e) {}
    var initVar = V.filter(function (v) { return String(v.id) === String(urlVariant || pdp.getAttribute('data-variant-id')); })[0];
    if (initVar) {
      state.color = colorOf(initVar);
      var it = tierOf(initVar);
      state.qty = (urlVariant && it > 0) ? TIER_MIN[it] : (parseInt(qInput && qInput.value, 10) || 1);
    } else {
      var act = pdp.querySelector('.pdp-swatch.is-active');
      state.color = act ? act.getAttribute('data-color-name') : (hasColor ? colorOf(V[0]) : null);
      state.qty = parseInt(qInput && qInput.value, 10) || 1;
    }

    function setUrlVariant(id) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', id);
        if (u.href !== window.location.href) window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }

    function repriceTable() {
      if (!hasTiers) return;
      $$('.bulk-pricing label[data-bulk-qty]', pdp).forEach(function (row) {
        var rowTier = parseInt(row.getAttribute('data-tier'), 10) || 0;
        var v = resolve(state.color, rowTier);
        var strong = row.querySelector('strong');
        if (strong) {
          var small = strong.querySelector('small');
          // Keep the sale treatment when repricing: the row is rebuilt on every colour change, and
          // writing only the price here erased the struck original that Liquid rendered.
          var priceHTML = money(v ? v.price : 0);
          if (v && v.cmp && v.cmp > v.price) {
            priceHTML = '<s class="bulk-pricing__was">' + money(v.cmp) + '</s>'
              + '<em class="bulk-pricing__now">' + money(v.price) + '</em>';
          }
          strong.innerHTML = (small ? small.outerHTML : '') + priceHTML;
        }
        row.setAttribute('data-bulk-price', money(v ? v.price : 0));
        if (v) row.setAttribute('data-variant-id', v.id);
      });
    }

    function syncTier() {
      var t = tierForQty(state.qty);
      if (hasTiers) {
        var rows = $$('.bulk-pricing label[data-bulk-qty]', pdp);
        var activeTier = displayTierFor(state.color, t);
        rows.forEach(function (row, i) {
          var on = row.getAttribute('data-tier') === String(activeTier);
          row.classList.toggle('is-selected', on);
          var sm = row.querySelector('strong > small');
          if (!on && sm) sm.remove();
          if (on) {
            var st = row.querySelector('strong');
            if (st && !st.querySelector('small')) st.insertAdjacentHTML('afterbegin', '<small>Selected</small>');
          }
        });
        var active = rows.filter(function (row) { return row.getAttribute('data-tier') === String(activeTier); })[0];
        if (active) {
          var qb = pdp.querySelector('[data-bind-bulk-qty]');
          var pb = pdp.querySelector('[data-bind-bulk-price]');
          if (qb) qb.textContent = active.getAttribute('data-bulk-qty');
          if (pb) pb.textContent = active.getAttribute('data-bulk-price');
        }
      }
      var variant = resolve(state.color, t);
      if (variant) {
        if (priceEl) priceEl.textContent = money(variant.price);
        // The struck original has to track the colour/tier too, or it keeps showing the price of
        // whichever variant happened to render first.
        var cmpEl = pdp.querySelector('[data-bind-pdp-compare]');
        if (cmpEl) {
          var onSaleNow = variant.cmp && variant.cmp > variant.price;
          cmpEl.hidden = !onSaleNow;
          if (onSaleNow) {
            var unitTxt = cmpEl.getAttribute('data-unit') || '';
            cmpEl.textContent = money(variant.cmp) + unitTxt;
          }
        }
        var availEl = pdp.querySelector('[data-bind-pdp-available]');
        if (availEl) availEl.textContent = variant.iq > 0 ? variant.iq : 'Pre-order';
        // The SKU markup has carried a [data-bind-pdp-sku] hook all along, but nothing ever wrote
        // to it, so the Specifications tab kept showing the first variant's SKU while every other
        // field updated around it. A variant with no SKU hides the row rather than showing a stale
        // one from the previously selected colour.
        // Client 08/31: show the MAIN product SKU only — the base 1-4 tier one, without the "-t"
        // suffix the bulk tiers carry. So the SKU tracks the colour but deliberately ignores the
        // quantity tier; resolve(colour, 0) is that base variant.
        var skuEl = pdp.querySelector('[data-bind-pdp-sku]');
        if (skuEl) {
          var skuVariant = resolve(state.color, 0) || variant;
          skuEl.textContent = skuVariant.sku || '';
          var skuRow = skuEl.closest('[data-spec-sku-row]');
          if (skuRow) skuRow.hidden = !skuVariant.sku;
        }
        pdp.setAttribute('data-variant-id', variant.id);
        // Stock state: out of stock (unavailable) / preorder (tracked + sold out, continue-selling) / in stock.
        var st = !variant.available ? 'oos' : (variant.im && variant.iq <= 0 ? 'preorder' : 'instock');
        if (addBtn) {
          addBtn.setAttribute('data-variant-id', variant.id);
          addBtn.classList.remove('is-instock', 'is-preorder', 'is-oos');
          addBtn.classList.add('is-' + st);
          addBtn.disabled = (st === 'oos');
          var lbl = st === 'oos' ? (addBtn.getAttribute('data-oos-label') || 'Out Of Stock')
            : st === 'preorder' ? (addBtn.getAttribute('data-preorder-label') || 'Preorder')
            : addLabel;
          var sp = addBtn.querySelector('[data-pdp-cta-label]') || addBtn.querySelector('span');
          if (sp) sp.textContent = lbl;
        }
        var swBtn = pdp.querySelector('.pdp-swatch-btn');
        if (swBtn) swBtn.disabled = (st === 'oos');
        setUrlVariant(variant.id);
      }
    }

    function setColor(name, el) {
      state.color = name;
      $$('.pdp-swatch', pdp).forEach(function (b) {
        var on = b === el;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var nm = pdp.querySelector('[data-bind-color-name]');
      if (nm) nm.textContent = name;
      if (el) { var img = el.getAttribute('data-image'); if (img && heroImg) swapPdpHero(pdp, img); }
      repriceTable();
      syncTier();
    }

    // A thumbnail is a variant's photo, so picking it picks that colour — routed through setColor so
    // price, compare-at, the bulk table, data-variant-id and ?variant= all follow the same path a
    // swatch click takes. Returns false for products whose photos aren't attached to a colour, where
    // the caller falls back to a plain image swap.
    function selectByThumb(el) {
      var name = el && el.getAttribute('data-pdp-color');
      if (!hasColor || !name) return false;
      var sw = $$('.pdp-swatch', pdp).filter(function (b) { return b.getAttribute('data-color-name') === name; })[0];
      if (!sw) return false;
      setColor(name, sw);
      // A colour can own more than one photo; keep the one that was actually clicked.
      var url = el.getAttribute('data-pdp-image');
      if (url && url !== sw.getAttribute('data-image')) swapPdpHero(pdp, url);
      return true;
    }

    function setQty(q) {
      state.qty = Math.max(1, parseInt(q, 10) || 1);
      if (qInput) qInput.value = state.qty;
      syncTier();
    }

    // Initial paint — align table + price + URL with the deep-linked / default selection.
    if (hasColor && state.color) {
      var match = $$('.pdp-swatch', pdp).filter(function (b) { return b.getAttribute('data-color-name') === state.color; })[0];
      if (match) { setColor(state.color, match); } else { repriceTable(); syncTier(); }
    } else {
      repriceTable();
      syncTier();
    }
    if (qInput) qInput.value = state.qty;

    pdp.addEventListener('click', function (e) {
      var sw = e.target.closest('.pdp-swatch');
      if (sw) { e.preventDefault(); setColor(sw.getAttribute('data-color-name'), sw); return; }

      var videoThumb = e.target.closest('.pdp-thumb[data-pdp-video]');
      if (videoThumb) { e.preventDefault(); setPdpVideo(pdp, videoThumb.getAttribute('data-pdp-video')); return; }

      var thumb = e.target.closest('.pdp-thumb[data-pdp-image]');
      if (thumb) {
        e.preventDefault();
        if (!selectByThumb(thumb)) setPdpImage(pdp, thumb.getAttribute('data-pdp-index'));
        return;
      }

      var dot = e.target.closest('[data-pdp-dot]');
      if (dot) {
        e.preventDefault();
        var dotIdx = dot.getAttribute('data-pdp-dot');
        if (!selectByThumb(pdp.querySelector('.pdp-thumb[data-pdp-index="' + dotIdx + '"]'))) setPdpImage(pdp, dotIdx);
        return;
      }

      var step = e.target.closest('[data-action="pdp-inc"], [data-action="pdp-dec"]');
      if (step) { e.preventDefault(); setQty(state.qty + (step.getAttribute('data-action') === 'pdp-inc' ? 1 : -1)); return; }

      var row = e.target.closest('.bulk-pricing label[data-bulk-qty]');
      if (row) {
        e.preventDefault();
        var rowTier = parseInt(row.getAttribute('data-tier'), 10) || 0;
        setQty(TIER_MIN[rowTier] || 1);
        return;
      }

      var buy = e.target.closest('[data-action="pdp-swatch-buy"]');
      if (buy) {
        e.preventDefault();
        var sv = swatchVariant(state.color) || V.filter(function (v) { return tierOf(v) === -1; })[0];
        if (sv && window.OCP_cartAdd) window.OCP_cartAdd(sv.id, 1, buy);
        return;
      }
    });

    if (qInput) qInput.addEventListener('change', function () { setQty(qInput.value); });
  }

  // ---------- LAZY HYDRATE PRODUCT GRIDS ----------
  function hydrateProductGrids() {
    $$('[data-product-grid]').forEach(function (grid) {
      // Render only if grid wasn't preserved as static markup.
      // Server-rendered (Liquid) grids already contain real product cards — never
      // overwrite them with the OCP_PRODUCTS mock catalogue.
      if (grid.getAttribute('data-rendered') === 'true' || grid.querySelector('.pcard')) return;
      var src = grid.getAttribute('data-product-source');
      var products = (window.OCP_PRODUCTS || []).slice();
      if (src === 'trending') products = products.filter(function (p) { return p.tag === 'top' || p.tag === 'sale'; });
      if (src === 'featured') products = products.filter(function (p) { return p.featured; });
      var limit = parseInt(grid.getAttribute('data-limit') || '0', 10);
      if (limit) products = products.slice(0, limit);
      grid.innerHTML = products.map(productCardHTML).join('');
      grid.setAttribute('data-rendered', 'true');
    });
  }

  // ---------- ALL-PRODUCTS PAGE ----------
  // Progressive enhancement over STATIC cards: filter by show/hide + reorder.
  // (Shopify Liquid will eventually render the cards + handle filter/sort/paginate
  //  server-side; this keeps the static DOM as the source of truth.)
  function renderAllProducts() {
    var listEl = document.getElementById('products-list');
    if (!listEl) return;
    // Review 08/07: never run the legacy static-catalogue filter/count on the server-rendered OCP
    // collection/search grids. It was overwriting the real product count (e.g. showing "24" — the page
    // size — instead of the true total) and re-ordering real cards. Those grids own their own count/grid.
    if (listEl.getAttribute('data-rendered') === 'true' || (listEl.closest && listEl.closest('.ocp-collection-page, .ocp-search-page'))) return;
    var cards = $$('.pcard', listEl);
    if (!cards.length) return; // static cards not present — nothing to enhance

    var byId = {};
    (window.OCP_PRODUCTS || []).forEach(function (p) { byId[p.id] = p; });

    var params = new URLSearchParams(location.search);
    var q = (params.get('q') || '').toLowerCase();
    var cat = params.get('cat') || '';
    var sort = document.getElementById('sort-select');
    var sortVal = sort ? sort.value : 'featured';
    var checks = $$('input[data-filter]:checked');
    var activeSegBtn = document.querySelector('.seg .seg__btn.is-active');
    var seg = activeSegBtn ? (activeSegBtn.getAttribute('data-seg') || 'all') : 'all';

    function matches(p) {
      if (!p) return true;
      if (q && (p.name + ' ' + (p.desc || '')).toLowerCase().indexOf(q) < 0) return false;
      if (cat === 'sale' && p.tag !== 'sale') return false;
      if (cat && cat !== 'sale' && p.cat && p.cat.indexOf(cat) < 0) return false;
      // segment maps to a Shopify product tag (e.g. "pattern" / "solid"); 'all' = no filter
      if (seg && seg !== 'all' && (p.cat || []).indexOf(seg) < 0) return false;
      for (var i = 0; i < checks.length; i++) {
        var f = checks[i].getAttribute('data-filter');
        var v = checks[i].value;
        if (f === 'fiber' && (p.fibers || []).indexOf(v) < 0) return false;
        if (f === 'color' && (p.colors || []).indexOf(v) < 0) return false;
      }
      return true;
    }

    var visible = [];
    cards.forEach(function (card) {
      var p = byId[card.getAttribute('data-product-id')];
      var show = matches(p);
      card.hidden = !show;
      if (show) visible.push(card);
    });

    if (sortVal !== 'featured') {
      visible.sort(function (a, b) {
        var pa = byId[a.getAttribute('data-product-id')] || {};
        var pb = byId[b.getAttribute('data-product-id')] || {};
        if (sortVal === 'price-asc')  return (pa.price || 0) - (pb.price || 0);
        if (sortVal === 'price-desc') return (pb.price || 0) - (pa.price || 0);
        if (sortVal === 'rating')     return (pb.rating || 0) - (pa.rating || 0);
        return 0;
      });
      visible.forEach(function (c) { listEl.appendChild(c); });
    }

    var countEl = document.getElementById('products-count');
    if (countEl) countEl.textContent = visible.length + ' products';

    var empty = listEl.querySelector('.empty-state');
    if (!visible.length) {
      if (!empty) {
        empty = document.createElement('p');
        empty.className = 'empty-state';
        empty.textContent = 'No products match those filters.';
        listEl.appendChild(empty);
      }
      empty.hidden = false;
    } else if (empty) {
      empty.hidden = true;
    }

    initCardSliders();
  }

  // ---------- PRODUCT DETAIL PAGE ----------
  function renderProductDetail() {
    var page = document.getElementById('product-detail');
    if (!page) return;
    if (page.getAttribute('data-pdp-hydrated') === 'true') return;
    page.setAttribute('data-pdp-hydrated', 'true');

    var productShell = $('.pdp__info[data-product-id]', page);
    var id = productShell ? productShell.getAttribute('data-product-id') : '';
    var p = getProduct(id) || getProduct('sateen-natural') || (window.OCP_PRODUCTS || [])[0];
    if (p && p.name) document.title = p.name + ' — Organic Cotton Plus';

    function setActiveProductImage(index) {
      var idx = Math.max(0, parseInt(index, 10) || 0);
      var thumb = page.querySelector('[data-pdp-index="' + idx + '"]');
      var img = page.querySelector('[data-bind-pdp-image]');
      if (thumb && img) img.src = thumb.getAttribute('data-pdp-image');
      $$('.pdp-thumb', page).forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-pdp-index') === String(idx));
      });
      var dots = $$('[data-pdp-dot]', page);
      var activeDot = dots.length ? Math.min(idx, dots.length - 1) : -1;
      dots.forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-pdp-dot') === String(activeDot));
      });
    }

    // qty + add wiring
    page.addEventListener('click', function (e) {
      var bulk = e.target.closest('.bulk-pricing label[data-bulk-qty]');
      if (bulk) {
        e.preventDefault();
        var table = bulk.closest('.bulk-pricing');
        $$('.bulk-pricing label[data-bulk-qty]', table).forEach(function (row) {
          row.classList.remove('is-selected');
          var selected = row.querySelector('small');
          if (selected) selected.remove();
        });
        bulk.classList.add('is-selected');
        var strong = bulk.querySelector('strong');
        if (strong && !strong.querySelector('small')) strong.insertAdjacentHTML('afterbegin', '<small>Selected</small>');
        var qtyBind = $('[data-bind-bulk-qty]', table);
        var priceBind = $('[data-bind-bulk-price]', table);
        if (qtyBind) qtyBind.innerHTML = bulk.getAttribute('data-bulk-qty') || '';
        if (priceBind) priceBind.textContent = bulk.getAttribute('data-bulk-price') || '';
        return;
      }
      var thumb = e.target.closest('[data-pdp-image]');
      if (thumb) {
        setActiveProductImage(thumb.getAttribute('data-pdp-index'));
        return;
      }
      var dot = e.target.closest('[data-pdp-dot]');
      if (dot) {
        setActiveProductImage(dot.getAttribute('data-pdp-dot'));
        return;
      }
      var b = e.target.closest('[data-action]');
      if (!b) return;
      var act = b.getAttribute('data-action');
      var qty = document.getElementById('pdp-qty');
      if (act === 'pdp-inc' && qty) qty.value = (parseInt(qty.value, 10) || 1) + 1;
      if (act === 'pdp-dec' && qty) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
      if (act === 'pdp-add') {
        var n = Math.max(1, parseInt(qty && qty.value, 10) || 1);
        for (var i = 0; i < n; i++) addToCart(id || (p && p.id));
      }
      if (act === 'pdp-swatch') addToCart(id || (p && p.id));
    });
  }

  // ---------- INIT ----------
  function init() {
    // Cart shell theme setting (default popup, per approved Figma). Shopify: settings.cart_type.
    if (!document.body.getAttribute('data-cart-style')) {
      document.body.setAttribute('data-cart-style', window.OCP_CART_STYLE === 'drawer' ? 'drawer' : 'popup');
    }
    buildCartPopup();
    hydrateProductGrids();
    renderAllProducts();
    renderProductDetail();
    initPdpPicker();
    refresh();
    initCardSliders();
    initPriceSliders();
    initBackToTop();
    initJudgemeWidget();
    window.addEventListener('load', initJudgemeWidget);
    document.addEventListener('ocp:collection-swapped', function () {
      initCardSliders();
      initPriceSliders();
    });
    initPdpThumbSlider();
    updateRailArrows();
    bindRailScroll();
    window.addEventListener('scroll', syncStickyCheckout, { passive: true });
    window.addEventListener('resize', syncStickyCheckout);
    window.addEventListener('load', updateRailArrows);
    window.addEventListener('resize', function () { clearTimeout(window.__ocpRailTimer); window.__ocpRailTimer = setTimeout(updateRailArrows, 200); });

    // Legacy client-side filter/sort (mock data). Skip entirely when the real native filter form is
    // present — assets/ocp-collection.js then owns filtering/sort via the Section Rendering API.
    if (!document.querySelector('[data-ocp-filter-form], [data-ocp-sort-form]')) {
    // Listen for filter changes on All Products page
    var filtersBox = document.getElementById('filters');
    if (filtersBox) filtersBox.addEventListener('change', function () {
      syncMobileFiltersFromDesktop();
      updateActiveFilterUI();
      renderAllProducts();
    });
    var sortSel = document.getElementById('sort-select');
    if (sortSel) sortSel.addEventListener('change', function () {
      updateActiveSortLabel();
      syncMobileSortFromDesktop();
      renderAllProducts();
    });

    // Mobile filters sheet — sync changes to the (hidden) desktop sidebar so existing logic still works
    var filtersSheet = document.getElementById('filters-sheet');
    if (filtersSheet) {
      filtersSheet.addEventListener('change', function (e) {
        var input = e.target;
        if (!input.matches('[data-filter-mobile]')) return;
        var f = input.getAttribute('data-filter-mobile');
        var v = input.value;
        var twin = document.querySelector('input[data-filter="' + f + '"][value="' + v + '"]');
        if (twin) { twin.checked = input.checked; twin.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    }

    var sortSheet = document.getElementById('sort-sheet');
    if (sortSheet) {
      sortSheet.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-sort-mobile]');
        if (!btn) return;
        var val = btn.getAttribute('data-sort-mobile');
        $$('[data-sort-mobile]', sortSheet).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (sortSel) { sortSel.value = val; sortSel.dispatchEvent(new Event('change', { bubbles: true })); }
        closeSheet(sortSheet);
      });
    }

    updateActiveFilterUI();
    updateActiveSortLabel();
    syncMobileFiltersFromDesktop();
    syncMobileSortFromDesktop();
    } // end legacy client-side collection filter/sort (skipped when native filtering is active)
  }

  // ---------- BOTTOM SHEETS ----------
  function openSheet(sheet) {
    if (!sheet) return;
    sheet.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-sheet-open');
    var first = sheet.querySelector('button, [tabindex="0"]');
    if (first) first.focus();
  }
  function closeSheet(sheet) {
    if (!sheet) return;
    sheet.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-sheet-open');
  }
  function syncMobileFiltersFromDesktop() {
    $$('[data-filter-mobile]').forEach(function (m) {
      var f = m.getAttribute('data-filter-mobile');
      var v = m.value;
      var twin = document.querySelector('input[data-filter="' + f + '"][value="' + v + '"]');
      if (twin) m.checked = twin.checked;
    });
  }
  function syncMobileSortFromDesktop() {
    var sel = document.getElementById('sort-select');
    if (!sel) return;
    $$('[data-sort-mobile]').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-sort-mobile') === sel.value);
    });
  }
  function updateActiveSortLabel() {
    var sel = document.getElementById('sort-select');
    if (!sel) return;
    var label = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].textContent : 'Sort';
    bind('active-sort-label', label);
  }
  function updateActiveFilterUI() {
    var checks = $$('input[data-filter]:checked');
    var n = checks.length;
    $$('[data-bind="active-filter-count"]').forEach(function (el) {
      el.textContent = String(n);
      if (n > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    var chipsHTML = checks.map(function (c) {
      return '<span class="chip-active">' + c.value
        + '<button type="button" aria-label="Remove ' + c.value + '" data-action="remove-filter"'
        + ' data-filter="' + c.getAttribute('data-filter') + '" data-value="' + c.value + '">&times;</button></span>';
    }).join('');
    $$('[data-bind="active-chips"], [data-bind="active-chips-desktop"]').forEach(function (box) {
      box.innerHTML = chipsHTML;
    });
  }
  function clearAllFilters() {
    $$('input[data-filter]').forEach(function (c) { c.checked = false; });
    $$('input[data-filter-mobile]').forEach(function (c) { c.checked = false; });
    updateActiveFilterUI();
    renderAllProducts();
  }
  function removeFilter(name, value) {
    var d = document.querySelector('input[data-filter="' + name + '"][value="' + value + '"]');
    var m = document.querySelector('input[data-filter-mobile="' + name + '"][value="' + value + '"]');
    if (d) d.checked = false;
    if (m) m.checked = false;
    updateActiveFilterUI();
    renderAllProducts();
  }

  /* ----------------------------------------------------------------------
     Wishlist Hero placeholders on cards.

     When the built-in wishlist is off, ocp-pcard renders an empty
     .wishlist-hero-custom-button in the heart's slot and the app fills it in. The app only scans
     for those placeholders once, at page load, and only re-watches its product-page id afterwards —
     so every card this theme paints later (filtering, load more, search popup, recommendation
     rails) would arrive with an empty slot. Observing the document is used rather than calling the
     app from each of those code paths, because it covers them all including any added later.

     The app exposes exactly one re-render hook, and its detail IS the element:
       document.dispatchEvent(new CustomEvent('wishlist-hero-add-to-custom-element', {detail: el}))
     Placeholders the app has already filled have a child node, so they are skipped — dispatching
     twice would render a second heart into the same slot.
     ---------------------------------------------------------------------- */
  function initWishlistHeroCards() {
    if (BUILTIN_WISHLIST) return;

    function render(el) {
      if (!el || el.firstElementChild) return;
      document.dispatchEvent(new CustomEvent('wishlist-hero-add-to-custom-element', { detail: el }));
    }

    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.classList.contains('wishlist-hero-custom-button')) render(node);
          var inner = node.querySelectorAll && node.querySelectorAll('.wishlist-hero-custom-button');
          if (inner) for (var k = 0; k < inner.length; k++) render(inner[k]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('DOMContentLoaded', initWishlistHeroCards);
  } else {
    init();
    initWishlistHeroCards();
  }

  // expose for inline use if needed
  window.OCP = {
    addToCart: addToCart,
    toggleWish: toggleWish,
    refresh: refresh
  };
})();
